module.exports = __webpack_public_path__ + "img/keyword.c69226cd.svg";